import { EVENTS_SAVE_DRAFT, EVENTS_SAVE_DRAFT_SUCCESS, EVENTS_SAVE_DRAFT_ERROR, EVENTS_SAVE_DRAFT_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const EventsSaveDraft = (state = initialState, action) => {
  switch (action.type) {
    case EVENTS_SAVE_DRAFT:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case EVENTS_SAVE_DRAFT_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case EVENTS_SAVE_DRAFT_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case EVENTS_SAVE_DRAFT_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default EventsSaveDraft;
